<template lang="pug">
vs-row
  v-modal-confirm(:isOpen="isConfirmModalOpen" :form="form" attribute="name" :msgType="1" @onClose="toggleConfirm" @onAccept="onDeleteRecord" param="aseguradora" :isLoading="isLoading")
  v-modal-carrousel-insurers(:form="form" :isOpen="isOpen" @onClose="onClose" :isAdd="isAdd")
  vs-col(:w="12")
    vs-row(justify="flex-end")
      vs-button(animation-type="scale" size="large" @click="onAddRecord")
        | Agregar
        template(#animate)
          i.eva.eva-plus-outline
  vs-col(:w="12" class="section-wrapper__container__table")
    vs-table(class="table-custom" striped ref="table")
      template(#thead)
        vs-tr(:data="columns")
          vs-th(v-for="(column, index) in columns" :key="index" class="table-custom__th")
            span {{ column }}
          vs-th
      template(#tbody)
        vs-tr(v-for='(insurer, index) in insurers' :key='index' :data='insurer' class="table-custom__tbody__tr")
          vs-td
            | {{ insurer.id }}
          vs-td
            | {{ insurer.name }}
          vs-td
            | {{ insurer.created_at | moment("DD MMMM YYYY") }}
          vs-td
            v-buttons-menu-table(:data="insurer" @onEditRecord="onEditRecord" @onDeleteRecord="onDeleteRecordConfirm")
      template(#footer)
        .table-custom__pagination
          vs-pagination(v-model="page" :length="pagination.totalPages" not-arrows)
</template>

<script>
import LoaderMixin from '@/mixins/LoaderMixin'
import PagesMixin from '@/mixins/PagesMixin'
import VButtonsMenuTable from '../tables-menu/ButtonsMenuTable.vue'
import { VModalCarrouselInsurers, VModalConfirm } from '@/components/modals'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Insurers')

export default {
  name: 'HomeButtonsTable',
  components: {
    VModalCarrouselInsurers,
    VButtonsMenuTable,
    VModalConfirm
  },
  mixins: [LoaderMixin, PagesMixin],
  data: () => ({
    columns: ['id', 'name', 'Creado el:'],
    page: 1,
    form: {}
  }),
  computed: {
    ...mapGetters(['insurers', 'pagination', 'filterParams'])
  },
  watch: {
    page () {
      this.onLoadRecords()
    }
  },
  async created () {
    await this.setupFilters({
      where: {
        page_id: this.$route.params.id,
        param: ''
      }
    })
    await this.applyFilter(this.filters)
  },
  methods: {
    ...mapActions(['loadRecords', 'deleteRecord', 'applyFilter'])
  }
}
</script>
